var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "suggestions-wrapper" }, [
    _c("div", { staticClass: "suggestions-title" }, [
      _vm._v(_vm._s(_setup.TEXT.title)),
    ]),
    _c(
      "div",
      { staticClass: "suggestions-container" },
      _vm._l(_setup.SUGGESTIONS, function (suggestion, idx) {
        return _c(
          "div",
          {
            key: idx,
            staticClass: "suggestion-card",
            on: {
              click: function ($event) {
                return _setup.handleClick(suggestion)
              },
            },
          },
          [
            _c("span", { staticClass: "suggestion-text" }, [
              _vm._v(_vm._s(suggestion)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }